import React from 'react';
import css from '@/css/module/new-world.css';
import flex from '@/css/module/flex.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { errorMsgToHtml } from '@/util';
import { useDrilldownError } from '@/features/drilldown/hooks';

export const LoadingError = () => {
  const errorMessage = useDrilldownError();

  // only show the error message if datatable is false (without this, drilldown on cached results fails because it kills the original query loading in the background)
  if (!errorMessage) return null;

  return (
    <div className={css.chartContainer}>
      <div className="data-table">
        <h5>Oops! Problem loading results</h5>
        <div className="alert alert-danger">
          <div className={flex.alignItemsStart}>
            <div className="margin-right-10">
              <FontAwesomeIcon icon="bomb" />
            </div>
            <div>{errorMsgToHtml(errorMessage)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
